import { useDocumentTitle, siteTitle } from "@1-now/booking-core";
import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { useData } from "data/data-provider";
import BackRouteButton from "shared/BackRouteButton/BackRouteButton";

export interface ListingCarPageProps {
  className?: string;
}

const AvailableCarsPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { companyDetails } = useData();
  // "Available cars — <operator>", always, like Vehicles (1NOW-11189).
  useDocumentTitle(companyDetails ? siteTitle(companyDetails, "Available cars") : undefined);
  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >

      <div className="container relative">
        <div className="mt-2">
          <BackRouteButton />
        </div>
        <SectionGridFilterCard className="mt-12 pb-24 lg:pb-28" />
      </div>
    </div>
  );
};

export default AvailableCarsPage;
